// Libs
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';
// Context
import {
  cloneDeep, find, remove
} from 'lodash';
import Badge from '@material-ui/core/Badge';
import { isMobile } from 'react-device-detect';
import SwipeableViews from 'react-swipeable-views';
import { toast } from 'react-toastify';
import { useComponentsPool } from '../../../ComponentsPool';
// Actions
import {
  deleteTickets, updateTicket, getTickets
} from '../actions';
import Chip from '@material-ui/core/Chip';

// isMobile
import { Toast } from '../../notification/components';
import Checkbox from '@material-ui/core/Checkbox';

import { openTicket } from '../helper';
import { EVENT_MOVE_TICKET, segmentTrack } from '../../layout/helper';
import Tooltip from '@material-ui/core/Tooltip';

export default React.memo(props => {
  const { Component } = useComponentsPool();
  const dispatch = useDispatch();
  const isDragging = props.isDragging;
  const [isSelected, setIsSelected] = useState(false);
  const [t] = useTranslation();
  const hasFloor = props.groupPositionName || props.groupFloorName;
  const ticketCounter = props.ticket?.custom_field?.counter && props.ticket?.custom_field?.counter !== '1' && props.ticket?.custom_field?.counter !== 1
    ? props.ticket.custom_field?.counter
    : null;
  const canHaveCheckboxOnTicket =
    !isMobile &&
    (props.enableUpdateStatus
      || (!props.enableUpdateStatus && props.ticket.status === 'NEW'));

  const toggleSelection = React.useCallback(() => {
    const selectedTickets = cloneDeep(props.getFootBarList());
    if (find(selectedTickets, t => t?.id === props?.ticket?.id)) {
      remove(selectedTickets, t => t?.id === props?.ticket?.id);
    } else {
      selectedTickets.push(props.ticket);
    }
    props.updateFootBar({
      selected: selectedTickets.map(t => t?.id),
      list: selectedTickets,
      type: 'ticket'
    });
  }, [props.getFootBarList, props.ticket]);

  const onClick = React.useCallback(e => {
    openTicket(e, dispatch, { close: props.closeFootBar }, { update: props.updateModal }, props?.ticket, isSelected)
  }, [
    dispatch,
    props.closeFootBar,
    props.updateModal,
    props.ticket,
    isSelected
  ]);

  useEffect(() => {
    setIsSelected(find(cloneDeep(props.getFootBarList()), obj => obj?.id === props?.ticket?.id));
  }, [props.getFootBarList]);


  const ticketElement = (
    <Badge
      badgeContent={ticketCounter}
      color="primary"
      classes={ticketCounter > 0
        ? { root: 'makeStyles-root-336', badge: 'makeStyles-badge-335' }
        : { root: 'makeStyles-root-336' }}
    >
      <div
        tabIndex={0}
        role={'button'}
        className={`ticket-view ${isDragging ? 'dragging' : ''} ${isSelected ? 'selected' : ''}`}
        onClick={onClick}
      >
        {
          props.hasRightOnPriority && <div className={`ticket-level level-${props.ticket.priority}`} />
        }
        <div className={'upper-part'}>
          <div className={'upper-part-key'}>{`#${props.ticket.key}`}</div>
          {canHaveCheckboxOnTicket
            ? (<Tooltip
              className={'tooltip'}
              classes={{ tooltip: 'table-tooltip' }}
              placement={'top'}
              title={!isSelected ? t('tickets:select_ticket') : t('tickets:unselect_ticket')}
            >
              <Checkbox
                checked={isSelected}
                onChange={toggleSelection}
              />
            </Tooltip>)
            : null
          }
        </div>
        <div className={'middle-part'}>
          <div className={'ticket-title-wrapper'}>
            <Tooltip
              placement="top"
              title={props.skillName ? t(`groups:${props.skillName}`) : ''}
            >
              <div>
                <Component componentName={'Icon'} type={props.skillName || 'tickets'} />
              </div>
            </Tooltip>
            <Tooltip placement="top" title={props.ticket.title?.length > 40 ? props.ticket.title : ''}>
              <p>{props.ticket.title}</p>
            </Tooltip>
          </div>
          <div className={'ticket-creation-date-wrapper'}>
            {moment(props.ticket.created_at).format('DD/MM/YY HH[h]mm')}
          </div>
        </div>
        <div className={'lower-part'}>
          <div className={'group-wrapper' + (hasFloor ? ' group-wrapper-with-floor' : '')}>
            {props.groupBatimentName
              ? (
                <Chip
                  label={props.groupBatimentName}
                />
              ) : null}
            {hasFloor
              ? <div className={"ticket-view-floor"}>{props.groupFloorName || props.groupPositionName}</div>
              : null}
          </div>
          {props.enableUpdateStatus &&
            <Component
              componentName={'UserAvatarsGrouped'}
              usersByGroups={props.assigners?.split('___')?.filter((u) => u !== '')?.map(user => find(props.users, u => u?.id === user))}
              shortenText
            />
          }
        </div>
      </div>
    </Badge>
  )

  if (isMobile) {
    const views = [];
    if (props.enableUpdateStatus) {
      views.push(
        <div className={`container-status-choices ticket-view ${isDragging ? 'dragging' : ''} ${isSelected ? 'selected' : ''}`}>
          {
            props.categories.split('___').map(category => (
              <div
                className="status-choice"
                onClick={() => {
                  const resolutionTime = moment.duration(
                    moment().diff(moment(props?.ticket?.created_at))
                  );
                  const segmentData = {
                    ticketId: props?.ticket?.id,
                    ticketOldColumn: props?.ticket?.status,
                    ticketCurrentColumn: category
                  };
                  if (category === 'COMPLETED') segmentData.ticketResolutionTimeInHours = resolutionTime.asHours();
                  segmentTrack(EVENT_MOVE_TICKET, segmentData);
                  dispatch(updateTicket(props?.ticket?.id, { status: category }))
                    .then(() => {
                      toast(
                        <Toast
                          isConfirm
                          message={t('notifications:ticket_swipe_ticket_success')}
                          icon={'check'}
                          type={'successful'}
                        />, {
                        position: toast.POSITION.BOTTOM_LEFT,
                        className: 'normal',
                        bodyClassName: 'notification-body grow-font-size',
                        progressClassName: 'successful-progress-bar'
                      }
                      );
                      // If isSupervisorMode user only update his ticket (so default mode my_tickets)
                      dispatch(getTickets(true, props.isSupervisorMode));
                    });
                }
                }
              >
                <span className="label noselect container-swipe">
                  <span className="noselect">
                    {t('tickets:swipe_mobile')}
                  </span>
                  <span className="column_label noselect">
                    {t(`tickets:${category}_mobile`)}
                  </span>
                </span>
              </div>
            ))}
        </div>
      );
    }
    views.push(ticketElement);
    if (props.enableDelete) {
      views.push(
        <div
          style={{ backgroundColor: 'red' }}
          className={`container-delete-ticket ticket-view ${isDragging ? 'dragging' : ''} ${isSelected ? 'selected' : ''}`}
          onClick={() => {
            dispatch(deleteTickets({ ticket_ids: [props?.ticket?.id] }));
          }}
        >
          <span className="label">{t('tickets:delete_mobile')}</span>
          <Component componentName={'Icon'} type={'trash'} />
        </div>
      );
    }
    let initialView;
    if (views.length > 2) {
      initialView = 1;
    } else if (views.length !== 2 || props.enableDelete) {
      initialView = 0;
    } else {
      initialView = 1;
    }
    return (
      <SwipeableViews index={initialView}>
        {views}
      </SwipeableViews>
    );
  }

  return ticketElement;
}, (prevProps, nextProps) => {
  return (
    prevProps.ticket.id === nextProps.ticket.id
    && prevProps.categories === nextProps.categories
    && prevProps.enableDelete === nextProps.enableDelete
    && prevProps.isSupervisorMode === nextProps.isSupervisorMode
    && prevProps.hasRightOnPriority === nextProps.hasRightOnPriority
    && prevProps.enableUpdateStatus === nextProps.enableUpdateStatus
    && prevProps.getFootBarList === nextProps.getFootBarList
    && prevProps.updateFootBar === nextProps.updateFootBar
    && prevProps.closeFootBar === nextProps.closeFootBar
    && prevProps.updateModal === nextProps.updateModal
    && prevProps.skillName === nextProps.skillName
    && prevProps.groupBatimentName === nextProps.groupBatimentName
    && prevProps.groupFloorName === nextProps.groupFloorName
    && prevProps.groupPositionName === nextProps.groupPositionName
    && prevProps.users === nextProps.users
    && prevProps.assigners === nextProps.assigners
  );
});
